import {ScreenLock} from "../../__constants/lock-screen";

const $ = jQuery.noConflict();
export const mobileMenu = (() => {
    const menu = $('.main-header .actions');
    const close = menu.find('.close');
    const hamburger = $('.main-header .hamburger');

    hamburger.on('click', () => {
        ScreenLock.lock();
        menu.addClass('active');
    });

    close.on('click', () => {
        ScreenLock.unlock();
        menu.removeClass('active');
    });
});
